import { Injectable } from "@angular/core"

@Injectable({
    providedIn: 'root',
})
export class NumberUtilsService {
    Round(value: number): number {

      //primero redondeamos a 3 decimales y luego a 2 para evitar errores de precision
      let threDecimals = Math.round(value * 1000) / 1000;
      let twoDecimals = Math.round(threDecimals * 100) / 100;
      return twoDecimals;

    }
}